import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import BusinessCard from "@/components/BusinessCard";

export default function CategoryPage() {
  const { province, district, slug } = useParams();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(null);
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/categories").then(({ data }) => {
      setCats(data);
      if (slug) setCat(data.find((c) => c.slug === slug));
    });
  }, [slug]);

  useEffect(() => {
    const params = {};
    if (slug) params.category_slug = slug;
    if (province) params.province = decodeURIComponent(province).replace(/-/g, " ");
    if (district) params.district = decodeURIComponent(district);
    api.get("/businesses", { params }).then(({ data }) => setItems(data));
  }, [province, district, slug]);

  const title = useMemo(() => {
    const parts = [];
    if (cat) parts.push(cat.name);
    if (province) parts.push(decodeURIComponent(province));
    if (district) parts.push(decodeURIComponent(district));
    return parts.join(" · ") || "Tüm İşletmeler";
  }, [cat, province, district]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-6">
      <h1 className="text-2xl font-bold tracking-tight mb-1">{title}</h1>
      <p className="text-sm text-muted-foreground mb-4">{items.length} işletme bulundu</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((b) => <BusinessCard key={b.id} business={b} categories={cats} />)}
          </div>
    </div>
  );
}
